import React from 'react';
import { useTranslation } from 'react-i18next';
import './CardShuffleLoading.scss';

export default function CardShuffleLoading() {
    const { t } = useTranslation();
    return <div className="card-shuffle-loading" role="status" aria-label={t('common.loading')}>
        <div className="shuffle-pack" aria-hidden="true">
            {['♠', '♥', '♦', '♣', '♠'].map((suit, index) => <span key={index}
                className={`shuffle-card${index === 1 || index === 2 ? ' shuffle-card--red' : ''}`} style={{ '--card-index': index }}>{suit}</span>)}
        </div>
        <span>{t('common.loading')}</span>
    </div>;
}
